import { Delivery } from './components/delivery/Delivery'
import './App.scss'

function App() { 
    return (
        <>
          <Delivery />
        </>
    );
}

export default App;
